<template>
  <!-- 金額摘要 -->
  <div class="deposit-frame-n">
    <div class="deposit-detail-n">
      <div class="list">
        <b>{{ $t('Bao.deposit_amount') }}</b>
        <span>{{ amount | numberFormat }}</span>
        <span v-if="paymentCode === 'MaShangPay'">$</span>
        <span v-else>{{ isAmoPay ? '＄' : currency }}</span>
      </div>

      <template v-if="!isDailyMultipleDeposit">
        <div class="list">
          <b>{{ $t('Bao.event_bonus') }}</b>
          <span>{{ eventBonus | numberFormat }}</span>
        </div>
        <div class="list text-gold">
          <b>{{ $t('Bao.deposit_total_tip') }}</b>
          <span>{{ totalBonus | numberFormat }}</span>
          <span v-if="paymentCode === 'MaShangPay'">$</span>
          <span v-else>{{ isAmoPay ? '＄' : currency }}</span>
        </div>
      </template>
    </div>

    <!-- 說明文字（非買幣模式才顯示） -->
    <div v-if="!isBuyCrypto" class="deposit-detail-n">
      <p v-if="isDailyMultipleDeposit">
        {{ $t('Bao.deposit_credit') }} {{ depositCount }}<br>
        {{ $t('Bao.deposit_credit_illustrate') }}<br><br>
        <template v-if="paymentCode === 'VegaWallet'">
          {{ $t('Bao.payment_vega_describe_1') }}<br>
          {{ $t('Bao.payment_vega_describe_2') }}
          <a href="https://vega-wallet.com/whitelist/" target="_blank" class="blue-link">
            {{ $t('Bao.payment_vega_describe_3') }}
          </a>
        </template>
        <template v-else>
          {{ $t('Bao.payment_bank_describe_1') }}<br>
          {{ $t('Bao.payment_bank_describe_2') }}
        </template>
      </p>
      <p v-else-if="paymentCode === 'VegaWallet'">
        {{ $t('Bao.payment_vega_describe_1') }}<br>
        {{ $t('Bao.payment_vega_describe_2') }}
        <a href="https://vega-wallet.com/whitelist/" target="_blank" class="blue-link">
          {{ $t('Bao.payment_vega_describe_3') }}
        </a>
      </p>
      <p
        v-else-if="paymentCode === 'YSpay'"
        style="white-space: pre-line;"
        v-text="$t('Bao.payment_yspay_describe')"
      />
      <p
        v-else-if="paymentCode === 'YSpay_convenience'"
        style="white-space: pre-line;"
        v-text="$t('Bao.payment_yspay_convenience_describe')"
      />
      <p v-else>
        {{ $t('Bao.payment_bank_describe_1') }}<br>
        {{ $t('Bao.payment_bank_describe_2') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepositSummary',
  props: {
    paymentCode: {
      type: String,
      default: ''
    },
    paymentName: {
      type: String,
      default: ''
    },
    amount: {
      type: [String, Number],
      default: 0
    },
    /** 加密幣換算後的日幣金額 */
    currencyRateValue: {
      type: [String, Number],
      default: 0
    },
    eventBonus: {
      type: [String, Number],
      default: 0
    },
    /** 總計（金額 + 獎勵），由父層計算後傳入 */
    totalBonus: {
      type: [String, Number],
      default: 0
    },
    /** 目前選中的活動 type，用於判斷是否為每日多次存款 */
    selectedEventType: {
      type: String,
      default: ''
    },
    /** 每日多次存款次數 */
    depositCount: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: ''
    },
    isBuyCrypto: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isAmoPay() {
      return this.paymentCode === 'AmoPay'
    },
    isDailyMultipleDeposit() {
      return this.selectedEventType === 'daily_multiple_deposit'
    }
  }
}
</script>
